<template >
  <div>
    <order-content buttonName="下一步" @response = "orderSubmit" :coupons="coupons" :selectCoupon="selectCoupon" @updateSelectCoupon="updateSelectCoupon"
                                    :productInfo = "productInfo" :showpromotion="true" :showButton = "showButton" v-if="isSsoFlag">
    <div class="list-block media-list" style="margin-top: 5px;margin-bottom:0;">
      <ul>
        <li>
          <a class="item-link item-content" @click="goToMyCoupons" >
            <div class="item-inner item-title-row">
              <div class="item-title">优　惠　券</div>
              <div class="item-after">
                <span v-if = "coupons.value.length === 0">无</span>
                <span v-else-if="selectCoupon"><span v-if="selectCoupon.label.indexOf('折券') !== -1">{{selectCoupon.label}}..</span> <span v-else >{{selectCoupon.label}}</span> <span v-if="selectCoupon.type !== 0 && selectCoupon.type !== 6">{{selectCoupon.value | currencyStyle}}</span></span>
                <span v-else>共{{coupons.value.length}}张</span>
              </div>
            </div>
          </a>

        </li>
      </ul>
    </div>


  </order-content>
    <order-content buttonName="提交审核" @response = "checkSubmit" :coupons="coupons" :showpromotion="true" :selectCoupon="selectCoupon" @updateSelectCoupon="updateSelectCoupon"
                   :productInfo = "productInfo"  :showButton = "showButton" v-else>
      <div class="list-block media-list" style="margin-top: 5px;margin-bottom:0;">
        <ul>
          <li>
            <a class="item-link item-content" @click="goToMyCoupons">
              <div class="item-inner item-title-row">
                <div class="item-title">优　惠　券</div>
                <div class="item-after">
                  <span v-if = "coupons.value.length === 0">无</span>
                  <span v-else-if="selectCoupon">{{selectCoupon.label}}<span v-if="selectCoupon.type !== 0 && selectCoupon.type !== 6">{{selectCoupon.value | currencyStyle}}</span></span>
                  <span v-else>共{{coupons.value.length}}张</span>
                </div>
              </div>
            </a>

          </li>
        </ul>
      </div>


    </order-content>
  </div>
</template>

<script>
  import $ from 'jquery'
  import {mapState, mapMutations} from 'vuex'
  import orderContent from './child/Order.vue'
  import emkt from '../../emkt'
  export default {
    mounted () {
      this.fetchData()
    },
    created () {
    },

    data () {
      return {
        address: [],
        distinct: 'myDiscount',
        coupons: {value: []},
        selectCoupon: emkt.getLocalStorage('myCoupons'),
        productInfo: {value: {}},
        showButton: true,
        isSsoFlag: this.emkt.buyCartIsLocalStorage
      }
    },
    components: {
      orderContent
    },
    methods: {
      ...mapMutations([
        'REMOVE_ALL_CHECKLIST_FROM_CART_LIST', 'ADD_ORDER', 'ADD_WAITPAID_ORDER', 'MYORDER_UPDATE'
      ]),
      fetchData () {
        this.address = this.sessionInfo.expressAddress
      },
      goToMyCoupons () {
        // coupon type = 6 筑研服务抵用券
        if (this.selectCoupon && this.selectCoupon.type && this.selectCoupon.type === 6) {
          $.toast('不支持更换抵用券')
          return
        }
        if (this.coupons.value.length > 0) {
          this.$router.push({name: 'myOrderCoupons', query: {myOrderCoupons: JSON.stringify(this.coupons.value)}})
        }
      },
      orderSubmit () {
//        let cName = this.address.userName
//        let aName = this.address.streetName
//        let tel = this.address.tel
        var self = this
//        console.log(this.productInfo)
        let bMerchandises = this.productInfo.value
        if (!bMerchandises) {
          return
        }
        let order
        bMerchandises.orderType = '1'
        $.showPreloader('正在进入结算方式页面，请稍等')
        this.showButton = false
        this.gcapi('orderSubmit', bMerchandises).then(response => {
          if (response.body.code === 1) {
            $.toast(response.body.message)
            return
          }
          order = response.body.result
          order.expressFree = this.productInfo.value.expressFree
          this.ADD_WAITPAID_ORDER(order)
          this.REMOVE_ALL_CHECKLIST_FROM_CART_LIST()
          this.ADD_ORDER(order)
          emkt.setStoreItem('myCoupons', undefined)
        }).then(function () {
          return self.gcapi('retrieveMyOrder')
        }).then(function (response) {
          $.hidePreloader()
          if (response !== undefined) {
            self.MYORDER_UPDATE(response.body.result)
            self.$router.replace({name: 'orderContent', params: {order: order}})
          }
        })
      },
      checkSubmit () {
//        let cName = this.address.userName
//        let aName = this.address.streetName
//        let tel = this.address.tel
        // 将sf跳转链接的参数传给后台
        const paymentInfo = {}
        // paymentInfo.balanceType = emkt.getUrlParam('BalanceType') === '' ? 0 : emkt.getUrlParam('BalanceType')
        paymentInfo.payType = emkt.getUrlParam('PayType')
        paymentInfo.firstLevelEnterpriseNo = emkt.getUrlParam('FirstLevelEnterpriseNo')
        paymentInfo.firstLevelEnterpriseName = emkt.getUrlParam('FirstLevelEnterpriseName')
        paymentInfo.secondLevelEnterpriseNo = emkt.getUrlParam('SecondLevelEnterpriseNo')
        paymentInfo.secondLevelEnterpriseName = emkt.getUrlParam('SecondLevelEnterpriseName')
        paymentInfo.settlementAccountNo = emkt.getUrlParam('SettlementAccountNo')
        // paymentInfo.researchGroupNo = emkt.getUrlParam('ResearchGroupNo')
        // paymentInfo.researchGroupName = emkt.getUrlParam('ResearchGroupName')
        var self = this
        let bMerchandises = this.productInfo.value
        if (!bMerchandises) {
          return
        }
        let order
        this.showButton = false
        const currentQuoteNo  =  emkt.getUrlParam('QuoteNo')
        const sessionQuoteNo = self.sessionInfo.customerInfo.customerProperties['QuoteNo']
        if (currentQuoteNo !== sessionQuoteNo) {
          $.toast("当前报价登陆态失效，请重新打开产品录入页面")
          return
        }

        bMerchandises.sfQuoteNo = sessionQuoteNo
        bMerchandises.sfQuoteId = self.sessionInfo.customerInfo.customerProperties['QuoteId']
        bMerchandises.employeeNo = self.sessionInfo.customerInfo.employeeOnBehalf
        bMerchandises.orderSource = '2'
        bMerchandises.clientSource = '1'
        bMerchandises.orderType = '1'
        bMerchandises.expressAddress = ''
        bMerchandises.expressContactor = ''
        bMerchandises.expressPhone = ''
        bMerchandises.merchantNo = '101'
        Object.assign(bMerchandises, paymentInfo)
        this.$weui.loading('正在提交审核 请耐心等待。')
       console.log(bMerchandises)
        this.gcapi('orderSubmit', bMerchandises).then(response => {
          if (response.body.code === 1) {
            this.$weui.loading().hide()
            $.toast(response.body.message)
            return
          }
          this.$weui.loading().hide()
          order = response.body.result
          order.expressFree = this.productInfo.value.expressFree
//          this.gcapi('orderSubmit', bMerchandises).then(response => {
//          })
          $.showPreloader('已生成报价，请在管理界面中进行商务、技术审核。')
          setTimeout(function () {
            $.hidePreloader()
          }, 1000)
          this.REMOVE_ALL_CHECKLIST_FROM_CART_LIST()
          // 更新数据库购物车信息
          const cartContent = JSON.stringify(this.cartList.cartContent) === '{}' ? null : JSON.stringify(this.cartList.cartContent)
          this.gcapi('saveShoppingCart', cartContent).then((response) => {
            if (response.body.code === 0) {
              console.log('数据库购物车已更新')
            } else {
              $.showPreloader('保存失败！')
              setTimeout(function () {
                $.hidePreloader()
              }, 1000)
            }
            emkt.goCart(self.$router)
          })
          emkt.setStoreItem('myCoupons', undefined)
          // self.$router.replace({name: 'cart'})

        }).then(function () {
          return self.gcapi('retrieveMyOrder')
        }).then(function (response) {
          $.hidePreloader()
          if (response !== undefined) {
            self.MYORDER_UPDATE(response.body.result)
          }
        })

      },
      updateSelectCoupon (coupon) {
        this.selectCoupon = coupon
        emkt.setStoreItem('myCoupons', coupon)
      }
    },
    computed: {
      ...mapState([
        'checkList', 'sessionInfo', 'cartList'
      ])
    },
    filters: {
      currencyStyle (val) {
        return ' ¥ ' + val
      }
    }
  }
</script>

<style type="text/css" scoped>
  .check-step {
    /*padding: 5px 0;*/
  }
  .item-title {
    padding-left: 1rem;
    color: #00469A;
    font-size: 0.75rem;
    font-weight: bold;
  }
  .check-step ul {
    display: -ms-flexbox;
    display: flex;
    margin: 25px 0 50px 0; }
  .check-step ul:after {
    visibility: hidden;
    display: block;
    content: " ";
    clear: both; }
  .check-step li {
    position: relative;
    float: left;
    -ms-flex: 1;
    flex: 1;
    width: 33%;
    line-height: 1.5em;
    padding: 0 1em 1em 1em;
    border-bottom: 2px solid #ccc;
    color: #999;
    font-size: 16px;
    text-align: center; }
  .check-step li:after {
    position: absolute;
    bottom: -7px;
    left: 50%;
    margin-left: -7px;
    content: "";
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #ccc; }
  .check-step li.cur {
    border-color: #EE7A23;
    color: #EE7A23;
    list-style-type:none}
  .check-step li.cur:after {
    background: #EE7A23; }

  @media only screen and (max-width: 767px) {
    .check-step ul {
    margin-left: -20px;
    margin-right: 20px; }
    .check-step li {
      font-size: 12px; } }

  .checkout-title {
    position: relative;
    margin-bottom: 10px;
    margin-top: 10px;
    text-align: center; }
  .checkout-title span {
    position: relative;
    padding: 0 1em;
    background-color: #EFEFF4;
    font-family: "moderat", sans-serif;
    font-weight: bold;
    font-size: 16px;
    color: #605F5F;
    z-index: 1; }
  .checkout-title:before {
    position: absolute;
    top: 50%;
    left: 0;
    content: "";
    width: 100%;
    height: 1px;
    background: #ccc;
    z-index: 0; }

</style>



// WEBPACK FOOTER //
// OrderContentConfirm.vue?48cfa1e0